import Image from 'next/image';

type AppLogoProps = {
  className?: string;
  markClassName?: string;
  textClassName?: string;
};

export default function AppLogo({ className = '', markClassName = '', textClassName = '' }: AppLogoProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Image
        src="/icons/licaio-icon-192.png"
        alt=""
        width={32}
        height={32}
        unoptimized
        className={`h-8 w-8 rounded-xl border border-white/20 shadow-sm ${markClassName}`}
      />
      <span className={`text-sm font-semibold ${textClassName}`}>Licaio</span>
    </div>
  );
}
